/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext } from 'react';

import {
  SoftwareCatalogInput,
  SoftwarePackage,
} from '@totem/components/software/software_report/types';
import { emptyId } from '@totem/components/userContext/security/userUtilities';

interface Context {
  loading: boolean;
  organizationId: string;
  monitoredOnly: boolean;
  setMonitoredOnly: (value: boolean) => void;
  data: SoftwarePackage[];
  rawData: SoftwarePackage[];
  action: string;
  actionItem: SoftwarePackage;
  onAction?: (action: string, item: SoftwarePackage) => void;
  input: SoftwareCatalogInput;
  setInput: (input: SoftwareCatalogInput) => void;
  selectedPackages: SoftwarePackage[];
  setPackageSelected: (
    softwarePackage: SoftwarePackage,
    selected: boolean,
  ) => void;
}

export default createContext<Context>({
  loading: false,
  organizationId: emptyId,
  monitoredOnly: false,
  setMonitoredOnly: (value: boolean) => {},
  data: null,
  rawData: null,
  action: '',
  actionItem: null,
  onAction: () => {},
  input: {},
  setInput: () => {},
  selectedPackages: [],
  setPackageSelected: () => {},
});
